import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { useTranslation } from 'react-i18next';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { getFormattedAddress } from '../../utils/providerDetails.utils';
import { capitalizeFirstLetters } from '../../utils/providerNames.utils';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { phoneOnly } from '../ConstantsStyles';
import {
  CallContainer,
  ModalTitle,
  PhoneTag,
  ResponsiveText,
  phoneTextStyle,
} from './CareTeamProviderCard.styled';

export const CallModal = ({ isOpen, onClose, data }) => {
  const mobileScreen = useMediaQuery(phoneOnly);
  const { t } = useTranslation();

  const [includeProviderGroupName] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.INCLUDE_PROVIDER_GROUP_NAME,
  ]);
  return (
    <ModalDialog
      data-auto-testid="call-modal"
      data-testid="call-modal"
      header={t('Call')}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div>
        {data.map((clinic, index) => (
          <CallContainer
            data-testid={`call-container-${clinic.sectionType}-${clinic.id}`}
            key={index}
          >
            <Flex direction="column">
              {includeProviderGroupName &&
                clinic?.providerGroupsAffiliations?.[0] && (
                  <ModalTitle css={{ fontWeight: '700', paddingBottom: '4px' }}>
                    {capitalizeFirstLetters(
                      clinic?.providerGroupsAffiliations[0]?.value
                    )}
                  </ModalTitle>
                )}
              <ModalTitle css={{ fontWeight: '500', color: '#4B4D4F' }}>
                {getFormattedAddress(clinic?.address, includeProviderGroupName)}
              </ModalTitle>
            </Flex>

            <PhoneTag
              data-auto-testid={`data-card-phone-tag-${clinic.locationId}`}
              data-testid={`data-card-phone-tag-${clinic.locationId}`}
              href={`tel:${clinic?.phones?.phone?.[0]}`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <IconSymbol
                aria-label="Phone number"
                data-auto-testid={`data-card-phone-icon-${clinic.locationId}`}
                data-testid={`data-card-phone-icon-${clinic.locationId}`}
                icon="phone"
                isScreenReadable
                size={mobileScreen ? 18 : 24}
                title="Phone number"
              />
              <ResponsiveText
                color="$core.color.brand.60"
                css={phoneTextStyle}
                data-auto-testid={`data-card-phone-number-${clinic.locationId}`}
                data-testid={`data-card-phone-number-${clinic.locationId}`}
                fontWeight="bold"
              >
                {clinic.phones?.phone?.[0]
                  ? clinic?.phones?.phone?.[0]
                  : t('not_available')}
              </ResponsiveText>
            </PhoneTag>
          </CallContainer>
        ))}
      </div>
    </ModalDialog>
  );
};
